import type { TResult } from './models';

/** Функция, которая определяет, как каждое значение,
первоначально полученное в результате синтаксического анализа,
преобразуется перед возвратом
 */
const replacer = (_: string, value: unknown) => {
    if (typeof value === 'string')
        return {
            type: 'string',
            length: value.length,
        };

    if (typeof value === 'number')
        return {
            type: 'number',
            length: value.toString().replace(/[+.-]/g, '').length,
            isPositive: value >= 0,
            isInteger: Number.isInteger(value),
        };

    return value;
};

/** Функция для получения мета-информации из объекта*/
export const getMetaInfoFromObject = <T extends Record<string, unknown>>(data: T): TResult<T> => {
    const serializedData = JSON.stringify(data);

    return JSON.parse(serializedData, replacer);
};
